export default "__VITE_ASSET__CLD4Lmo2__"